import { render } from "./BigHealthyBox.vue?vue&type=template&id=c7e41b9a&scoped=true"
import script from "./BigHealthyBox.vue?vue&type=script&lang=js"
export * from "./BigHealthyBox.vue?vue&type=script&lang=js"

import "./BigHealthyBox.vue?vue&type=style&index=0&id=c7e41b9a&lang=less&scoped=true"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7e41b9a"]])

export default __exports__